export default "/images/vendor/flag-icon-css/flags/1x1/bg.svg?4f2a9bbb4c1ea18ea4dd2acca5d79160";